import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=82e7cd98&scoped=true&"
import script from "./editMenu.vue?vue&type=script&lang=js&"
export * from "./editMenu.vue?vue&type=script&lang=js&"
import style0 from "./editMenu.vue?vue&type=style&index=0&id=82e7cd98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e7cd98",
  null
  
)

export default component.exports